import useSeo from "@/hooks/useSeo";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import FeaturedWorks from "@/pages/home/components/FeaturedWorks";
import NewsHighlights from "@/pages/home/components/NewsHighlights";
import Sidebar from "@/pages/home/components/Sidebar";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  useSeo({
    title: "筱田优-最新影视资讯与作品介绍",
    description:
      "筱田优官方网站，提供最新的影视资讯、作品介绍及相关动态，涵盖电影电视剧资源和演员资料，满足影迷对筱田优全方位的了解需求。",
    keywords: "筱田优,影视资讯,电影作品,电视剧,演员介绍,影视动态",
  });

  return (
    <div className="w-full">
      <HeroCarousel />
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <FeaturedWorks />
            <NewsHighlights />
          </div>
          <Sidebar />
        </div>
      </div>
      <SiteIntro />
    </div>
  );
}